// This file is part of InvenioRDM
// Copyright (C) 2023 CERN.
// Copyright (C) 2022-2024 KTH Royal Institute of Technology.
//
// Invenio App RDM is free software; you can redistribute it and/or modify it
// under the terms of the MIT License; see LICENSE file for more details.

/**
 * Add here all the overridden components of your app.
 */

import { RecommendedInformationOverride } from "../../components/deposit/overrides/CommunityHeaderOverride.js";

export const overriddenComponents = {
  "InvenioAppRdm.Deposit.CommunityHeader.container": () => null,
  "InvenioAppRdm.Deposit.AccordionFieldRecommendedInformation.container":
    RecommendedInformationOverride,
};
